import React from 'react'
import Header from '../../components/header';
import MyNav from './nav'
import { connect } from 'react-redux'
import "./exam.css"

class MyExam extends React.Component  {
   constructor(props)
   {super(props);}
 
render(){
   return(
      <>
      <div className="exam-main-div1">
         <Header/>
         <MyNav/>
         </div>
       </>
   )
}
}
const mapStateToProps = state =>({auth:state.auth})
export default connect(mapStateToProps)(MyExam)